<template>
            <form
                id="enquire_form"
                @submit.prevent="submit"
                method="post"
                :class="{'success' : success}"
                class="full">
                 
                <span v-if="success" id="subscribe-form-body">
                    <div  class="message-sent">
                        <p>Thank You for Subscribing.</p>
                        <button type="submit" class="submit" @click="reloadForm">Subscribe with another e-mail</button>
                    </div>
                </span>
                
                <span v-else id="subscribe-form-body">
                    <p>Subscribe to our newsletter</p>
                    <!-- Google tag manager GCLID offline tracking managed by luux-media.com -->
                        <input data-drupal-selector="edit-gclid" type="hidden" name="utm_gclid" value="">
                        <input data-drupal-selector="edit-utm-source" type="hidden" name="utm_source" value="">
                        <input data-drupal-selector="edit-utm-medium" type="hidden" name="utm_medium" value="">
                        <input data-drupal-selector="edit-utm-campaign" type="hidden" name="utm_campaign" value="">
                        <input data-drupal-selector="edit-utm-content" type="hidden" name="utm_content" value="">
                        <input data-drupal-selector="edit-utm-term" type="hidden" name="utm_term" value="">
                    <div>
                        <input type="hidden" name="_token" :value="csrf">

                        <input                
                            type="email"
                            id="email"
                            required placeholder="Please enter your email address"
                            name="email"
                            v-model="userData.email"
                            >

                        <button class="right" type="submit" id="contact-submit">
                            <img class="center" src="/images/icons/ArrowRight.svg">
                        </button>
                    </div>
                </span>
            </form>
</template>

<script>
import Vue from 'vue'

export default {
    name: "subscribe-component",
    data() {
        let currentUrl = window.location.origin + this.$route.fullPath;
        let name = 'New Subscription ';
        return {
            currentUrl: '',
            form_url: '',
            userData: {
                utm_gclid: '',
                utm_source: '',
                utm_medium: '',
                utm_campaign: '',
                utm_content: '',
                utm_term: '',
                form_url: currentUrl,
                form_origin: 'Subscribe',
                name: name,
                email: '',
            },
            errors: {},
            success: false,
            loaded: true,
            csrf: document.head.querySelector('meta[name="csrf-token"]').content,
        } 
    },

    methods: {

        submit() {
                if (this.loaded) {
                    this.loaded = false;
                    this.success = false;
                    this.errors = {};
                     this.$axios.post('/submit', this.userData ).then(response => { 
                        this.userData.form_origin = '';
                        this.userData.name = '';
                        this.userData.email = '';
                        this.userData.form_url = '';
                        this.loaded = true;
                        this.success = true;
                        // window.scrollTo(0,0);
                    }).catch(error => {
                      if (error.response.status === 422) {
                          this.errors = error.response.data.errors || {};
                          }
                    });
                }
        },

        reloadForm() {
            this.errors = {};
            this.success = false;
            this.loaded = true;
            this.$forceUpdate();      
          },
        selectOption(option) {
            this.$emit('input', option)
        }
      }
    }
</script>
<style>
    #subscribe-form-body {
        button.submit {
            width: 100%;
            margin-top: 10px;
            font-size: 1rem;
            color: white;
        }
    }
</style>